import { getConfig } from '@cian/config/browser';

interface ILocalVariables {
  ymapsPromise?: Promise<YMaps.IYMaps>;
  scriptElement?: HTMLScriptElement;
}

export const localVarables: ILocalVariables = {
  ymapsPromise: undefined,
  scriptElement: undefined,
};

interface ILoadYmapsApiParams {
  satelliteApiKey?: string | null;
  force?: boolean;
}

export function loadYmapsApi(options: YMaps.IReadyOptions, params: ILoadYmapsApiParams = {}): Promise<YMaps.IYMaps> {
  const config = getConfig();
  const rsApiKey = config.getStrict<string>('countryside.YandexApiKey');

  const { satelliteApiKey, force } = params;
  if (force) {
    delete localVarables.ymapsPromise;
    delete window.ymaps;
    if (localVarables.scriptElement) {
      window.document.body.removeChild(localVarables.scriptElement);
    }
  }
  if (force || !localVarables.ymapsPromise) {
    localVarables.ymapsPromise = new Promise((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);

        return;
      }

      localVarables.scriptElement = window.document.createElement('script');
      const apiKey = satelliteApiKey || rsApiKey;
      const apiType = satelliteApiKey ? '' : 'enterprise.';
      localVarables.scriptElement.src = `https://${apiType}api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru-RU&load=Map`;
      localVarables.scriptElement.async = true;
      localVarables.scriptElement.defer = true;
      localVarables.scriptElement.onload = () => {
        if (window.ymaps) {
          resolve(window.ymaps);
        }
      };
      localVarables.scriptElement.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(localVarables.scriptElement);
    });
  }

  return (localVarables.ymapsPromise as Promise<YMaps.IYMaps>).then(ymaps => ymaps.ready(options).then(() => ymaps));
}
